import type { AccountDisplayMode } from '@mm/shared';
import type { AppRef } from '../types/models';

type WithApps = { app?: AppRef; assignments?: { app: AppRef }[] };

/** Apps currently using an account (assignment rows), or the row's own app. */
export const accountApps = (a: WithApps): AppRef[] =>
  a.assignments?.map((x) => x.app) ?? (a.app ? [a.app] : []);

export const appNames = (a: WithApps) =>
  accountApps(a)
    .map((x) => x.name)
    .join(', ');

/**
 * Account label per Settings → Marketing → display mode:
 * ACCOUNT_ID "123-456-7890", ACCOUNT_NAME "RVC Google", BOTH "RVC Google (123-456-7890)".
 * Falls back to the other value when one is missing.
 */
export function accountLabel(
  a: { accountName: string; accountIdentifier: string | null },
  mode: AccountDisplayMode = 'BOTH',
) {
  const id = a.accountIdentifier?.trim();
  if (mode === 'ACCOUNT_ID') return id || a.accountName;
  if (mode === 'ACCOUNT_NAME' || !id) return a.accountName;
  return `${a.accountName} (${id})`;
}
